import WaveMark from "./WaveMark";

type LogoProps = {
  compact?: boolean;
  className?: string;
};

export default function Logo({ compact = false, className = "" }: LogoProps) {
  return (
    <span className={`flex items-center gap-3 ${className}`}>
      <WaveMark className="h-6 w-9 md:h-7 md:w-11" />
      <span className="flex flex-col leading-none">
        <span className="font-heading text-xl tracking-[0.3em] text-foreground-50 md:text-2xl">
          MÂJI
        </span>
        {!compact && (
          <span className="mt-1 font-body text-[9px] uppercase tracking-[0.42em] text-secondary-500 md:text-[10px]">
            by Cerón
          </span>
        )}
      </span>
    </span>
  );
}